import React from 'react';
import { onChange, validateForm } from '../../utils';
import uniqid from 'uniqid';

class ComponentName extends React.Component<any, any>{
    clrInterval: any;
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : '',
            uid: detail ? detail.uid : uniqid(),
            bills: { name: 'bills', value: [], error: '', isRequired: false }
        }
    }

    render() {
        const { bills } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Bill(s)</label>
                                        <input
                                            name={bills.name}
                                            onChange={this.onChange}
                                            type="file"
                                            multiple={true}
                                            className="form-control"
                                            style={{ padding: 4 }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        {
                                            Array.from(bills.value).map(function (item: any, index: number) {
                                                return (
                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                    </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.files;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            this.props.onSubmit(st.bills.value);
        }
    }

}

export default ComponentName;
